export var OrderPurpose;
(function (OrderPurpose) {
    OrderPurpose["FRIEND_BIRTHDAY"] = "friend-birthday";
    OrderPurpose["FRIEND_GATHERING"] = "friend-gathering";
    OrderPurpose["BIRTHDAY"] = "birthday";
    OrderPurpose["DATE"] = "date";
    OrderPurpose["ANNIVERSARY"] = "anniversary";
    OrderPurpose["SPECIAL_DAY"] = "special-day";
    OrderPurpose["FAMILY"] = "family";
    OrderPurpose["BUSINESS"] = "business";
})(OrderPurpose || (OrderPurpose = {}));
/**
 * 畫面上的用餐目的選項與順序（2026-10-06 定案）。
 * 「朋友慶生」「週年慶」已隱藏不再提供選擇，enum 保留是為了舊單仍能顯示。
 */
export const ORDER_PURPOSE_OPTIONS = [
    OrderPurpose.BIRTHDAY,
    OrderPurpose.DATE,
    OrderPurpose.SPECIAL_DAY,
    OrderPurpose.FAMILY,
    OrderPurpose.BUSINESS,
    OrderPurpose.FRIEND_GATHERING,
];
